import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const marriageSchemaObject = {
  surnameHusband: yup.string().required('Campo obbligatorio'),
  nameHusband: yup.string().required('Campo obbligatorio'),
  surnameWife: yup.string().required('Campo obbligatorio'),
  nameWife: yup.string().required('Campo obbligatorio'),
  genderHusband: yup.string().required('Campo obbligatorio'),
  genderWife: yup.string().required('Campo obbligatorio'),
  marriageDate: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
  marriageMunicipality: yup.string().required('Campo obbligatorio'),
  yearDateHusband: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  yearsHusband: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  yearDateWife: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  yearsWife: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
};

const createSchema = yup.object().shape(marriageSchemaObject);

export default createSchema;
